(($) => {
  $(() => {
    const $modal = $('#mega-menu-modal');

    if ($modal.length) {
      const $headingEl      = $modal.find('.modal-title');
      const $itemsList      = $('.mega-menu-modal__items-list');

      $modal.on({
        'show.bs.modal': (e) => {
          const $relatedTarget = $(e.relatedTarget);
          const $heading       = $relatedTarget.closest('.mega-menu__li').find('.mega-menu__heading').length
            ? $relatedTarget.closest('.mega-menu__li').find('.mega-menu__heading')
            : $relatedTarget.closest('.dropdown').find('.dropdown-toggle');
          const isShopMenu     = $relatedTarget.closest('nav[data-region="shop-menu"]').length
            ? true
            : false;
          const dataRegion     = $relatedTarget.closest('[data-region]').data('region');
          const $items         = $relatedTarget.closest('ul').find('li').clone();
          let $modalItems      = $items.addClass('col-12 col-md-4');

          $modalItems.find('a').removeClass('d-none').addClass('border border-dark-subtle p-2 d-flex align-items-center justify-content-center h-100')
          $modalItems.find('[role="button"]').remove();

          if(isShopMenu) {
            $modalItems = $modalItems.slice(1);
          }

          $headingEl.html($heading.html());
          $itemsList.html($modalItems);
          $modal.attr('data-region', dataRegion);
        },
        'hide.bs.modal': () => {
          $headingEl.html('');
          $itemsList.html('');
          $modal.attr('data-region', '');
        },
      });
    }
  });
})(jQuery);
